module.exports = __webpack_public_path__ + "imgs/tincture.49ef625faa3c05ed0ad2ff51d1b3325b.jpg";